import React, { Component } from 'react';
import { Box, Flex } from 'core/components';
import { observer } from 'mobx-react';
import DataViewWrapper from 'app/components/dataviews/DataViewWrapper';
import { ViewInExplorerButton } from 'app/components/dataviews/tools';
import Legend from 'app/components/dataviews/views/legend/Legend';
import ToolResultCard from '../components/ToolResultCard';

@observer
class SyslogToolResult extends Component {
  render() {
    const { tool, onDataViewCreate, onCloseToolResult, isInlineMode, onQueryError } = this.props;

    // Ensure tool and query_object exist before rendering DataViewWrapper
    if (!tool || !tool.query_object) {
      return <Flex>Invalid tool data for Syslog.</Flex>;
    }

    return (
      <ToolResultCard
        tool={tool}
        onCloseToolResult={onCloseToolResult}
        isInlineMode={isInlineMode}
        className="tool-result-syslog"
        title={tool.title}
        minHeight={750}
        headerActions={<ViewInExplorerButton query={tool.query_object} openInNewWindow text="View in Data Explorer" />}
      >
        <DataViewWrapper
          key="dataview"
          query={tool.query_object}
          allowCache
          onDataViewCreate={onDataViewCreate}
          headerProps={{
            showTitle: false,
            showTitleLink: false,
            showViewTypeTag: true,
            shouldArrangeVertically: false,
            showLastUpdated: false,
            showDateRange: true,
            showAppliedFilters: true,
            showDataSources: true,
            isDashboardView: true // makes the title size smaller
          }}
          fitToHeight
          viewProps={{
            showNativeLegend: false,
            hasFooter: true,
            height: 200 // Use a fixed height for the chart
          }}
        >
          {({ component, header, dataview, dataViewConfig }) => {
            if (dataview.errors.length > 0 && onQueryError) {
              onQueryError(dataview.errors);
            }

            const { showLegend } = dataViewConfig;
            return (
              <>
                <Box px={2} mt={-2} mb={1}>
                  {header}
                </Box>

                {component}
                {showLegend && dataview && <Legend dataview={dataview} includeTotalRow={false} />}
              </>
            );
          }}
        </DataViewWrapper>
      </ToolResultCard>
    );
  }
}

export default SyslogToolResult;
